import axios from '@/utils/request.js'

// 根据id获取收货数据
export function GetInboundDeliveryPrintData(data) {
    return axios({
        url: '/isc_gps/isc/gps/InboundDelivery/GetInboundDeliveryPrintData',
        method: 'Get',
        params: data
    })
}

// 查询仓库信息
export function GetWarehouseInfoList(data) {
    return axios({
        url: '/isc_gps/isc/gps/Common/GetWarehouseInfoList',
        method: 'Post',
        data
    })
}

//保存收货数据到数据库
export function SaveMovementData(data) {
    return axios({
        url: '/isc_gps/isc/gps/Movement/SaveMovementData',
        method: 'post',
        data
    })
}
